export default __webpack_public_path__ + "bc1b01d0b0c31e9fe14d74fe45585fd8.png";